import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg') || null,
    phoneNumber,
    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    qrCode: searchParams.get('qrCode'),
    startFrom: parseInt(searchParams.get('startFrom') || '') || 1,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    carousel: searchParams.get('carousel') || '0',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,

    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    titleFontSize: searchParams.get('titleFontSize') || '4.8',

    sizeQR: searchParams.get('sizeQR') || '20',
    paddingQR: searchParams.get('paddingQR') || '0',

    questionFontSize: searchParams.get('questionFontSize') || '4',
    answerFontSize: searchParams.get('answerFontSize') || '3.4',
    varNumFontSize: searchParams.get('varNumFontSize') || '6',

    winnerFontSize: searchParams.get('winnerFontSize') || '4',

    marginTopQuiz: searchParams.get('marginTopQuiz') || '0',
  };
};
